<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs row">
                        <div class="col-xs-12 col-sm-fill hidden-xs">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}
                            </h3>
                        </div>
                    </div>
                      

                    <!-- Row -->
                    <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                        <div class="row">

                            <div class="col-xs-6 col-md-6 col-lg-4 col-xl-3">
                                <div class="submit-field">
                                    <h5>Tipo do usuário:</h5>
                                    <select class="with-border" v-model="form.tipo" :disabled="form.cod">
                                        <!-- <option value="" disabled selected hidden>Selecione aqui..</option> -->
                                        <option value="admin">Administrador</option>
                                        <option value="prestador">Técnico</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-xl-12"></div>

                            <div class="col-md-12 col-lg-6 col-xl-4 col-xs-12">
                                <div class="submit-field">
                                    <h5>Nome:</h5>
                                    <input type="text" class="with-border" placeholder="Informe o nome..." v-model="form.nome">
                                </div>
                            </div>

                            <div class="col-md-12 col-lg-6 col-xl-4 col-xs-12">
                                <div class="submit-field">
                                    <h5>E-mail:</h5>
                                    <input type="email" class="with-border" placeholder="Informe o e-mail aqui" v-model="form.email">
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-4 col-xl-3 col-xs-7">
                                <div class="submit-field">
                                    <h5>Telefone:</h5>
                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone" />
                                </div>
                            </div>

                            <div class="col-xl-12 clearfix"></div>

                            <!-- Button -->
                            <div class="col-xl-12 margin-top-30">
                                <small class="help" v-show="$router.currentRoute.name == 'CadastrarUsuarios'">Após o cadastro, o usuário receberá no e-mail acima uma senha de acesso gerada pelo sistema.</small>
                                <button type="submit" v-if="form.ativo == 1 || !form.cod" class="button color-green block-mobile" v-bind:class="{'disabled': loading.submit }">
                                    <i class="las la-save"></i>
                                    Salvar alterações
                                </button>
                                <button v-if="form.cod && form.ativo == 1" type="button" v-on:click="del(form.cod)" class="button outline-gray block-mobile">
                                    <i class="las la-ban"></i>
                                    Desativar usuário
                                </button>                                                
                            </div>

                        </div>

                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'GerenciarUsuarios',
    components: {
        'AvatarCropper':            AvatarCropper,
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "salvo":                false,
            "loading": {
                "submit":           false
            },
            "categorias": {
                "itens":            []
            },
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "",
                "tipo":             "prestador",
                "email":            "",
                "telefone":         "",
                "empresaCod":       "",
                "dataNascimento":   "",
                "doc":              ""
            }            
        }
    },
    methods: {
        submitAvatar: function(e) {
            var self = this;
            console.log("submitAvatar()", e)
            loading.show();
        },    
        uploadAvatar: function(e) {
            var self = this;
            console.log("uploadAvatar()", e)
            loading.show();
            // self.form.imagem = e.getCroppedCanvas().toDataURL();
            e.getCroppedCanvas().toBlob((blob1) => {
                reduceFileSize(blob1, 500*1024, 800, Infinity, 0.6, blob2 => {
                    blobToBase64(blob2, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.form.imagem    = result;
                        self.$forceUpdate();
                    });
                });             
            });
            return true;
        },                    
        getBase64Imagem: function(event) {
            var self            = this;
            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 800, Infinity, 0.6, blob => {
                    blobToBase64(blob, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.form[event.target.id.split("-")[2]]    = result;
                    });
                }); 
            } else {
                setTimeout(function() {
                    loading.hide();
                }, 500);                
            } 
        },            
        escolherImagem: function(campo) {
            console.log("escolherImagem()", campo)
            var self = this;
            $(".uploadButton-button[for='upload-arquivo-" + campo + "']").click();        
            
        },      
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja desativar esse usuário?", function() {
                var form                = {};
                form._cod               = self.$root.user.cod;
                form._token             = self.$root.user.token;                 
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/usuarios.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.salvo          = true;                
                    self.loading.del    = false;
                    self.$root.back();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        submit: function(e) {
            var self            = this;
            if (self.form.ativo == 0) return false;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/usuarios.php", self.form)
            .then(response => {
                
                self.salvo          = true;
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("get() response", response);

                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    created: function() {
        var self = this;

    },
    activated: function() {
        var self = this;
        console.log("activated", self);

        if (self.$route.name == "EditarUsuarios") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }
    },    
    beforeRouteLeave (to, from, next) {
        var self = this;
        if (!self.salvo) {
            const answer = window.confirmWeb('Você tem certeza que deseja sair da página atual? Modificações não salvas podem ser perdidas.')
            if (!answer) return false;
        }
        next();
    }         
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .uploadButton-button {
        display: none !important;
    }        
    .button.gray.block-mobile {
        font-weight: 400;
        border: 1px solid #ddd !important;
    }

    .imagem-preview {
        width: 100%;
        height: 35vh;
        border-radius: 10px;
        margin-bottom: 25px !important;
        background-size: contain;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
    }
</style>



// WEBPACK FOOTER //
// src/components/GerenciarUsuarios.vue